module.exports = __webpack_public_path__ + "img/lights-holiday.7c999dfd.svg";